import * as React from "react";

import type { DesignaliProps } from "../../types";

export const FileVolume2 = React.forwardRef<SVGSVGElement, DesignaliProps>(
  ({ ...props }, forwardedRef) => {
    return (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        strokeWidth={2}
        strokeLinecap="round"
        strokeLinejoin="round"
        {...props}
        ref={forwardedRef}
      >
        <path d="M15 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V7Z" />
        <path d="M14 2v4a2 2 0 0 0 2 2h4" />
        <path d="M8 15h.01" />
        <path d="M11.5 13.5a2.5 2.5 0 0 1 0 3" />
        <path d="M15 12a5 5 0 0 1 0 6" />
      </svg>
    );
  },
);

export default FileVolume2;
